import pc from './pc.png';
import qc from './qc.png';
import onan2500 from './onan-p2500i.png';
import onan4500 from './onan-p4500i.png';
import onan9500 from './onan-p9500df.png';
import rs from './rs.png';

const images = {
  pc,
  qc,
  onan2500,
  onan4500,
  onan9500,
  rs,
};

export default images;



// WEBPACK FOOTER //
// ./src/views/Home/components/images/products/index.js